import { event, string } from "../schema-util";

import { noProps } from "./shared";

export const architecture = {
  "Opened architecture modal": noProps,
  "Closed architecture modal": noProps,
  "Saved architecture selection": event({
    architectureId: string(),
  }),
};
